import { render, staticRenderFns } from "./ReceiveMain.vue?vue&type=template&id=a47b5d9a&scoped=true&"
import script from "./ReceiveMain.vue?vue&type=script&lang=js&"
export * from "./ReceiveMain.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveMain.vue?vue&type=style&index=0&id=a47b5d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47b5d9a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VApp,VProgressCircular})


/* vuetify-loader */
import installDirectives from "!../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
